import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header: React.FC = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleLogoClick = () => {
    scrollToTop();
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [mobileMenuOpen]);

  const navLinks = [
    { to: '/hakkimizda', label: 'Hakkımızda' },
    { to: '/hizmetler', label: 'Hizmetler' },
    { to: '/referanslar', label: 'Referanslar' },
    { to: '/iletisim', label: 'İletişim' },
  ];

  return (
    <header
      className={`header ${scrolled ? 'header-scrolled' : ''}`}
      style={{
        background: scrolled ? 'rgba(255, 255, 255, 0.98)' : 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderBottom: scrolled ? '1px solid rgba(0, 0, 0, 0.06)' : '1px solid transparent',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        padding: '0.625rem 0',
        transition: 'all 0.2s ease',
        boxShadow: scrolled ? '0 1px 3px 0 rgba(0, 0, 0, 0.05)' : 'none',
      }}
    >
      <div
        className="container"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          maxWidth: 1280,
          margin: '0 auto',
          padding: '0 1.5rem',
        }}
      >
        {/* Logo */}
        <Link
          to="/"
          onClick={handleLogoClick}
          style={{
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
            transition: 'opacity 0.2s ease',
          }}
        >
          <img
            src="/Logo header.png"
            alt="Motopack Logo"
            style={{
              maxWidth: 72,
              maxHeight: 72,
              width: 'auto',
              height: 'auto',
              display: 'block',
            }}
          />
        </Link>

        {/* Burger Menu Button (Mobile) */}
        <button
          className="burger-menu-btn"
          aria-label="Menüyü Aç/Kapat"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          style={{
            display: 'none',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: 44,
            height: 44,
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            zIndex: 1201,
            borderRadius: 8,
            transition: 'background 0.2s ease',
          }}
        >
          <span style={{
            width: 24,
            height: 2.5,
            background: 'var(--primary-color)',
            margin: '2.5px 0',
            borderRadius: 2,
            transition: 'all 0.3s ease',
          }}></span>
          <span style={{
            width: 24,
            height: 2.5,
            background: 'var(--primary-color)',
            margin: '2.5px 0',
            borderRadius: 2,
            transition: 'all 0.3s ease',
          }}></span>
          <span style={{
            width: 24,
            height: 2.5,
            background: 'var(--primary-color)',
            margin: '2.5px 0',
            borderRadius: 2,
            transition: 'all 0.3s ease',
          }}></span>
        </button>

        {/* Desktop Navigation */}
        <nav
          className="nav-menu"
          style={{
            marginLeft: 'auto',
            display: 'flex',
            gap: '0.25rem',
            alignItems: 'center',
          }}
        >
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              onClick={handleLogoClick}
              className={`nav-link ${location.pathname === link.to ? 'active' : ''}`}
              style={{
                color: location.pathname === link.to ? 'var(--primary-color)' : 'var(--gray-600)',
                textDecoration: 'none',
                fontWeight: 500,
                fontSize: '0.9375rem',
                padding: '0.5rem 0.875rem',
                borderRadius: 8,
                transition: 'all 0.2s ease',
                position: 'relative',
                letterSpacing: '-0.01em',
              }}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* CTA Buttons */}
        <div
          className="cta-buttons"
          style={{
            marginLeft: '1rem',
            display: 'flex',
            gap: '0.625rem',
            alignItems: 'center',
          }}
        >
          <Link
            to="/hizmetal"
            onClick={handleLogoClick}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0.5rem 1rem',
              background: 'var(--primary-color)',
              color: '#fff',
              fontWeight: 600,
              fontSize: '0.875rem',
              borderRadius: 8,
              textDecoration: 'none',
              transition: 'all 0.2s ease',
              boxShadow: '0 1px 2px 0 rgba(0, 102, 204, 0.15)',
            }}
          >
            Kurye hizmeti al
          </Link>
          <Link
            to="/kuryeol"
            onClick={handleLogoClick}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0.5rem 1rem',
              background: 'transparent',
              color: 'var(--primary-color)',
              fontWeight: 600,
              fontSize: '0.875rem',
              borderRadius: 8,
              border: '1.5px solid var(--primary-color)',
              textDecoration: 'none',
              transition: 'all 0.2s ease',
            }}
          >
            Kurye ol
          </Link>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <div
        className={`mobile-menu-overlay ${mobileMenuOpen ? 'open' : ''}`}
        onClick={() => setMobileMenuOpen(false)}
        style={{
          display: mobileMenuOpen ? 'block' : 'none',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0, 0, 0, 0.4)',
          backdropFilter: 'blur(4px)',
          zIndex: 1200,
          opacity: mobileMenuOpen ? 1 : 0,
          transition: 'opacity 0.25s ease',
          pointerEvents: mobileMenuOpen ? 'auto' : 'none',
          cursor: 'pointer',
        }}
      />

      {/* Mobile Menu */}
      <div
        className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}
        style={{
          display: 'flex',
          flexDirection: 'column',
          position: 'fixed',
          top: 0,
          right: 0,
          width: '100%',
          maxWidth: 320,
          height: '100vh',
          background: '#fff',
          boxShadow: mobileMenuOpen ? '-8px 0 32px rgba(0, 0, 0, 0.1)' : 'none',
          zIndex: 1202,
          transform: mobileMenuOpen ? 'translateX(0)' : 'translateX(100%)',
          transition: 'transform 0.3s cubic-bezier(0.32, 0.72, 0, 1)',
          padding: '1.5rem',
          overflowY: 'auto',
        }}
      >
        {/* Mobile Menu Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          marginBottom: '2rem',
        }}>
          <button
            onClick={() => setMobileMenuOpen(false)}
            style={{
              background: '#f1f5f9',
              border: 'none',
              borderRadius: '50%',
              width: 40,
              height: 40,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              color: '#334155',
              transition: 'background 0.2s ease',
            }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <nav style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5rem',
        }}>
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              onClick={() => { setMobileMenuOpen(false); handleLogoClick(); }}
              style={{
                color: location.pathname === link.to ? 'var(--primary-color)' : '#334155',
                textDecoration: 'none',
                fontWeight: 600,
                fontSize: '1.125rem',
                padding: '1rem',
                borderRadius: 12,
                background: location.pathname === link.to ? 'rgba(0, 102, 204, 0.05)' : 'transparent',
                transition: 'all 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              {link.label}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.3 }}>
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </Link>
          ))}

          <div style={{
            height: 1,
            background: '#e2e8f0',
            margin: '1.5rem 0',
          }} />

          <Link
            to="/hizmetal"
            onClick={() => { setMobileMenuOpen(false); handleLogoClick(); }}
            style={{
              padding: '1rem',
              background: 'var(--primary-color)',
              color: '#fff',
              fontWeight: 600,
              fontSize: '1rem',
              borderRadius: 12,
              textDecoration: 'none',
              textAlign: 'center',
              boxShadow: '0 4px 12px rgba(0, 102, 204, 0.2)',
              marginBottom: '0.75rem',
            }}
          >
            Kurye Hizmeti Al
          </Link>

          <Link
            to="/kuryeol"
            onClick={() => { setMobileMenuOpen(false); handleLogoClick(); }}
            style={{
              padding: '1rem',
              background: '#fff',
              color: 'var(--primary-color)',
              fontWeight: 600,
              fontSize: '1rem',
              borderRadius: 12,
              border: '2px solid rgba(0, 102, 204, 0.1)',
              textDecoration: 'none',
              textAlign: 'center',
            }}
          >
            Kurye Ol
          </Link>
        </nav>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .nav-menu,
          .cta-buttons {
            display: none !important;
          }
          .burger-menu-btn {
            display: flex !important;
          }
        }

        .nav-link:hover {
          color: var(--primary-color) !important;
          background: var(--primary-lightest);
        }

        .nav-link.active {
          background: var(--primary-lightest);
        }

        .cta-buttons a:first-child:hover {
          background: var(--primary-dark) !important;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 102, 204, 0.25) !important;
        }

        .cta-buttons a:last-child:hover {
          background: var(--primary-lightest) !important;
          transform: translateY(-1px);
        }

        .burger-menu-btn:hover {
          background: var(--gray-50);
        }
      `}</style>
    </header>
  );
};

export default Header;